var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "activity-container"
  }, [_vm.showActivityIntro ? _c('activity-intro') : _vm._e(), _vm.dataLoaded && _vm.isMounted && _vm.showComponent ? _c('activity-loader') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }